import React from "react";
import { NavLink } from "react-router-dom";

export default function DataAnalyticsAIInsights() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Data Analytics & AI Insights</h1>
            <h5 className="text-muted">
              Transforming Raw Data into Strategic Intelligence with AI
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/data-analysis-concept-illustration_114360-1143.jpg"
              alt="Data Analytics AI"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Unlock the Power of Predictive Intelligence</h2>
            <p>
              <strong>Bytlas Intelligence</strong> combines cutting-edge AI with robust data analytics to
              help businesses make smarter decisions, faster. Our solutions uncover trends, predict
              outcomes, and identify growth opportunities hidden within your data.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Advanced Data Visualization & Dashboards</li>
              <li className="list-group-item">✅ AI-Powered Predictive Modeling</li>
              <li className="list-group-item">✅ Real-Time Business Intelligence</li>
              <li className="list-group-item">✅ Custom KPIs and Data Storytelling</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">From Data to Actionable Insights</h3>
            <p>
              We help you go beyond basic reports. Our AI-driven insights identify risks, predict trends,
              and recommend actions, empowering teams to act with confidence and speed.
            </p>
            <ul>
              <li>📊 Interactive Power BI & Tableau Dashboards</li>
              <li>📈 Trend Forecasting & Machine Learning Models</li>
              <li>💼 Departmental & C-Suite Decision Support</li>
              <li>🔍 Smart Anomaly & Pattern Detection</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Solutions Tailored for You</h3>
            <p>
              Whether you're in retail, finance, healthcare, or manufacturing, our solutions adapt
              to your industry needs and business goals.
            </p>
            <ul>
              <li>🏬 Retail & Customer Analytics</li>
              <li>🏥 Healthcare Performance Metrics</li>
              <li>🏦 Financial Forecasting & Risk Management</li>
              <li>🏭 Manufacturing Process Optimization</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Schedule a Data Strategy Consultation
          </NavLink>
        </div>
      </div>
    </section>
  );
}
